import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import axios from 'axios'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import matchType, { SPORTS_TYPE } from '../helper/index'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Swal from 'sweetalert2'
import { GET_SCORE_CARD, GLOBAL, MATCHLIST, MATCHLISTPUBSUB, SET_TEAM_DETAILS, MATCHLISTSLOTLIVE, MATCHSTATUSLIVE, MOVE_TO_FINISH, GET_ANALYTICS_DATA } from '../constant/endpoint';
import { useStyles } from '../constant/constant';
import { CircularProgress, Dialog, Grid, TextField, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import moment from "moment";
import {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
  } from "@mui/material";
  import { Tooltip } from "@mui/material";
  import { Switch, FormControlLabel } from "@mui/material";
  

export default function MatchList({ gst }) {
    const navigate = useNavigate();
    const [value, setValue] = React.useState('1');
    const [contextName, setContextName] = React.useState("UPCOMING")
    const [listData, setListData] = React.useState([]);
    const [defaultPage, setDefaultPage] = React.useState(1)
    const [totalPage, settotalPage] = React.useState(2)
    const [loading, setLoading] = React.useState(false)
    const [sort, setSort] = React.useState({});
    const [sport, setSport] = React.useState(1)
    const [toggleScoreCard, setToggleScoreCard] = React.useState({
        isOpen: false,
        match_id: "",
        series_id: ""
    })
    const classes = useStyles();
    const user = useSelector(state => state.loginSlice)
    const userProfile = !isEmpty(user?.token) ? jwtDecode(user?.token) : { accessLevel: 0 }

    //new 
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [selectedMatch, setSelectedMatch] = React.useState(null);
    const [selectedTime, setSelectedTime] = React.useState("");

    const handleActivateClick = (data) => {
        setSelectedMatch(data);
        setDialogOpen(true);
      
        if (data.prediction_match_live_time) {
          const formatted = moment(data.prediction_match_live_time).format("YYYY-MM-DDTHH:mm"); // For datetime-local
          setSelectedTime(formatted);
        } else {
          setSelectedTime(""); // Empty if not set
        }
      };
      

      const handleDialogConfirm = async () => {
        if (!selectedMatch) return;
      
        const userTime = moment(selectedTime);
        // const matchTime = moment(`${selectedMatch.star_date} ${selectedMatch.star_time}`, "YYYY-MM-DD HH:mm");

        // if (userTime.isAfter(matchTime)) {
        //     setDialogOpen(false);
        //   Swal.fire("Invalid Time", "Selected time cannot be after match start time.", "error");
        //   return;
        // }
        const curr_time = moment();
        if(userTime.isBefore(curr_time)){
           setDialogOpen(false);
           Swal.fire("Invalid Time", "Selected time cannot be before Current Time.", "error");
          return;
        }
      
        await updateLiveStatus(
        //   selectedMatch.prediction_match_live,
          selectedMatch._id,
          selectedMatch.match_id,
          selectedMatch.series_id,
          userTime
        );
      
        setDialogOpen(false);
      };

      const handleDialogClose = () => {
        setDialogOpen(false);
      };

    const handleChange = (event, newValue) => {
        setContextName(event.target.innerText)
        setValue(newValue)
        setDefaultPage(1)
        getMatchList(event.target.innerText.toLowerCase(), 1, sport)
    };
    const handleSportChange = (event, newValue) => {
        setSport(newValue)
        setDefaultPage(1)
        getMatchList(contextName.toLowerCase(), 1, newValue)
    }
    const handlePagination = async (e, p) => {
        let contentType = contextName.trim()
        await getMatchList(contentType.toLowerCase(), p, sport)
        setDefaultPage(p)
    }
    const getMatchList = async (status = gst ? 'result' : "upcoming", pageNumber = 1, sport = 1) => {
        setLoading(true)
        const response = await axios.get(`${MATCHLIST}&sport=${sport}`.replace(':status', status.trim() === 'live' ? 'running' : status.trim() === 'result pending' ? 'cancelled' : status.trim() === 'result' ? 'completed' : status.trim()).replace(':default', pageNumber))
        setLoading(false)
        if (response?.data?.status) {
            setListData(response?.data?.data.upcoming_match)
            settotalPage(response?.data?.data?.paginated_data?.totalPage)
        }
    }



    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}`)
    }

    const matchStatusUpdate = async (type, match_id, series_id) => {
        const data = {
            ...type, match_id, series_id
        }
        const result = await Swal.fire({
            title: `Do you want ${Object.values(data)[0] ? 'Active' : 'InActive'} to  the ${Object.keys(data)[0].replaceAll('_', ' ').replace('is', '').replace('avail', '')} ?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            await axios.post(`${MATCHLIST.replace('status=:status&page=:default', '')}`, data)
            let contentType = contextName.trim()
            await getMatchList(contentType.toLowerCase(), defaultPage, sport)
        }
    }

    const updateLiveStatus = async (id, match_id, series_id,live_time) => {
        const data = {
            id, sport,
            // status: status ? 0 : 1,
            match_id,
            series_id,
            live_time
        }
            await axios.patch(`${MATCHSTATUSLIVE}`, data)
            let contentType = contextName.trim()
            await getMatchList(contentType.toLowerCase(), defaultPage, sport)
        
    }

    const pubSubUpdate = async (type, match_id, series_id) => {
        const data = {
            ...type, match_id, series_id
        }
       
            await axios.post(`${MATCHLISTPUBSUB}`, data)
            let contentType = contextName.trim()
            await getMatchList(contentType.toLowerCase(), defaultPage, sport)
        
    }

    const slotLiveUpdate = async (type, match_id, series_id) => {
        const data = {
            ...type, match_id, series_id
        }
       
            await axios.post(`${MATCHLISTSLOTLIVE}`, data)
            let contentType = contextName.trim()
            await getMatchList(contentType.toLowerCase(), defaultPage, sport)
        
    }

    const scoreCardUpdate = async (e, match_id, series_id) => {
        let updateData = {
            scorecard: e.target.value,
            match_id,
            series_id
        }
        await axios.post(`${MATCHLIST.replace('status=:status&page=:default', '')}`, updateData)
        let contentType = contextName.trim()
        await getMatchList(contentType.toLowerCase(), defaultPage, sport)
    }

    const globalFiles = async (e, data) => {
        var formData = new FormData()
        formData.append('files', e.target.files[0]);
        formData.append('match_id', data.match_id);
        const response = await axios.post(GLOBAL.replace(':match_id', data.match_id), formData)
        if (response.data.status === 'success') {
            Swal.fire('Global Image Upload Successfully')
            let contentType = contextName.trim()
            await getMatchList(contentType.toLowerCase(), defaultPage, sport)
        } else {
            alert('something went wrong')
        }
    }

    React.useEffect(() => {
        getMatchList()
    }, [])
    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort: e.target.value } }))
        }
    }
    const handleShorting = async (data) => {
        data.sort = sort[data._id]?.sort ? sort[data._id]?.sort : data.sort
        if (!isEmpty(data.sort)) {
            let result = await axios.patch(MATCHLIST, data)
            if (result?.data?.status === 'success') {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        } else {
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Sorting must be filled',
                showConfirmButton: false,
                timer: 1500
            })
        }

    }
    const editScorecard = (matchId, seriesId) => {
        setToggleScoreCard({
            ...toggleScoreCard,
            isOpen: true,
            match_id: matchId,
            series_id:seriesId
        });

    }

    const moveToFinished = async (match_id, series_id, id, trade_avail) => {
        // const result = window.confirm(`Mark match ${id} as Finished?`);
        if (trade_avail === true) {
            await Swal.fire({
                icon: 'warning',
                title: '⚠️ Please deactivate trading first',
                text: 'You need to turn off trading before marking the match as finished.',
                confirmButtonText: 'Okay'
            });
            return;
        }
        const result= await Swal.fire({
            title: `Mark match  as Finished?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (!result.isConfirmed) return;
      
        try {
          const response = await axios.post(MOVE_TO_FINISH, {
            match_id: match_id,
            series_id: series_id,
            id: id
          });
      
          if (response.data.status) {
            Swal.fire("Match successfully marked as Finished")
            getMatchList("live", 1, sport)
          }
        } catch (error) {
          console.error("❌ Error:", error);
          alert("❌ Failed to update match status");
        }
      };
     const handleAnalyticsToogle = async (value, match_id, series_id) => {
            try {
                 const response = await axios.get(GET_ANALYTICS_DATA, {
                    params: {
                        match_id,
                        series_id,
                        has_analytics: value,
                    },
                    });
                    console.log(response.data)
                if (
                response.data &&
                response.data.status === 'success' && 
                response.data.data.status==true
                ) {
                    Swal.fire(response.data.data.message);
                    getMatchList(contextName.toLowerCase(),defaultPage,sport); // Call only on success
                }else{
                    Swal.fire(response.data.data.message);
                getMatchList(contextName.toLowerCase(),defaultPage,sport); // Call only on success
                }
            } catch (err) {
                console.error("Failed to toggle scorecard visibility", err);
            }
        };


      
    return (
        <>
                <Box sx={{ width: '100%', typography: 'body1' }} style={{ marginTop: "100px" }}>
                    <TabContext value={value}>
                        {!gst && <TabContext value={sport}><Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleSportChange} aria-label="lab API tabs example" style={{ display: "flex !important", justifyContent: "space-around !important" }} >
                                {
                                    SPORTS_TYPE.map((data, index) =>
                                        <Tab label={data.name} key={index} value={data.sport} title={data.name} />
                                    )
                                }
                            </TabList>
                        </Box></TabContext>}
                        {!gst && <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example" style={{ display: "flex !important", justifyContent: "space-around !important" }} >
                            {
                                matchType
                                .filter(type => type !== 'cancelled')
                                .map((data, index) => (
                                    <Tab
                                    label={
                                        data === 'running'
                                        ? 'Live'
                                        : data === 'completed'
                                        ? 'Result'
                                        : data
                                    }
                                    key={index}
                                    value={(index + 1).toString()}
                                    title={(index + 1).toString()}
                                    />
                                ))
                            }
                            </TabList>
                        </Box>}
                        <TabPanel value={value}>
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center"> Image</TableCell>
                                            <TableCell align="center">Match Id</TableCell>
                                            <TableCell align="center">Team vs Team</TableCell>
                                            <TableCell align="left">Series</TableCell>
                                            <TableCell align="left">Time Date</TableCell>
                                        <TableCell align="left">Type</TableCell>

                                            <TableCell align="left">On Live</TableCell>
                                        
                                            <TableCell align="left">Score Card</TableCell>
                                            {/* <TableCell align="left">Live Update</TableCell> */}
                                            {!gst && <>
                                                <TableCell align="center">Trading</TableCell>
                                                {userProfile.accessLevel > 60 && <TableCell align="center">QUIZ PLAY</TableCell>}
                                                <TableCell align="center">Skiller</TableCell>
                                        
                                                {/* <TableCell align="center">Poll</TableCell>
                                        <TableCell align="center">Opinion Pro</TableCell> */}

                                            </>
                                            }

                                            {gst && <TableCell align="center">Match Data</TableCell>}
                                            {!gst &&
                                                contextName === 'LIVE' &&
                                                <TableCell align="center">Sorting</TableCell>
                                            }
                                            {!gst &&
                                                contextName === 'UPCOMING' &&
                                                <TableCell align="center">Sorting</TableCell>
                                            }
                                            {!gst && contextName === 'LIVE' && (
                                                <TableCell align="center">Move</TableCell>
                                            )}

                                            {!gst && <TableCell align="center">Action</TableCell>}
                                              <TableCell align="left">Match Analytics</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listData.length > 0 ? listData?.map((data) => (
                                            <TableRow
                                                key={data.name}
                                            >

                                                <TableCell size='small' style={{ width: '10%' }}>
                                                    <img src={data.prediction_image} style={{ width: '85px' }} alt='' />
                                                    <input
                                                        style={{ width: '90px' }}
                                                        accept="image/*"
                                                        id="contained-button-file"
                                                        multiple
                                                        type="file"
                                                        onChange={(e) => globalFiles(e, data)}
                                                    />
                                                </TableCell>
                                                <TableCell>{data.match_id}</TableCell>
                                                <TableCell component="th" scope="row">
                                                    {data.local_team_name} Vs {data.visitor_team_name}
                                                </TableCell>
                                                <TableCell>{data.series_name}</TableCell>
                                                <TableCell align="left">{data.star_time}{' '}{data.star_date}</TableCell>
                                                <TableCell align="left">{data.type}</TableCell>
                                               
                                                    {/* <TableCell align="left">
                                                        <Button variant='contained' disabled={!data.is_trade_avail} color={data.prediction_match_live ? 'success' : 'error'} size="small" onClick={() => updateLiveStatus(data.prediction_match_live, data._id, data.match_id, data.series_id)} > {data.prediction_match_live ? 'Active' : 'InActive'}</Button>
                                                    </TableCell> */}
                                                
                                                <TableCell align="left">
                                                    <Tooltip
                                                        title={
                                                        data.prediction_match_live_time && data.prediction_match_live_time !== ""
                                                            ? `Live Time: ${moment(data.prediction_match_live_time).format("DD MMM YYYY, h:mm A")}`
                                                            : "Set Live Time"
                                                        }
                                                        disableHoverListener={!data.is_trade_avail}
                                                        disableFocusListener={!data.is_trade_avail}
                                                        disableTouchListener={!data.is_trade_avail}
                                                    >
                                                        <span
                                                        onClick={data.is_trade_avail ? () => handleActivateClick(data) : undefined}
                                                        style={{
                                                            cursor: data.is_trade_avail ? "pointer" : "not-allowed",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            opacity: data.is_trade_avail ? 1 : 0.4,
                                                            pointerEvents: data.is_trade_avail ? "auto" : "none", // blocks clicks
                                                        }}
                                                        >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="30"
                                                            width="30"
                                                            viewBox="0 0 24 24"
                                                            fill={
                                                            data.prediction_match_live_time && data.prediction_match_live_time !== ""
                                                                ? "#2e7d32"
                                                                : "#d32f2f"
                                                            }
                                                        >
                                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                                            <path d="M12 4a8 8 0 100 16 8 8 0 000-16zm0 2a6 6 0 110 12 6 6 0 010-12zm.5 3H11v5l4.28 2.54.72-1.21-3.5-2.08V9z" />
                                                        </svg>
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>


                                                {/* <TableCell align="left">
                                                    <Button style={{ marginBottom: "5px" }} disabled={data.scorecard ? false : true} variant='contained' color={'error'} size="small" onClick={() => editScorecard(data.match_id, data.series_id)} >Edit</Button>
                                                    <TextField defaultValue={'none'} value={data.scorecard || 'none'} select fullWidth onChange={(e) => scoreCardUpdate(e, data.match_id, data.series_id)}>
                                                        <MenuItem value={'none'}>Select Option</MenuItem>
                                                        <MenuItem value={'crikchamp'}>crikchamp</MenuItem>
                                                        <MenuItem value={'entity'}>entity</MenuItem>
                                                    </TextField></TableCell> */}
                                        
                                                <TableCell align="left">
                                                    <Button variant='contained' color={data.is_pub_sub ? 'success' : 'error'} size="small" onClick={() => pubSubUpdate(data.is_pub_sub ? { is_pub_sub: false } : { is_pub_sub: true }, data.match_id, data.series_id)} sx={{ marginTop: "8px", backgroundColor: data.is_pub_sub ? "success" : "error"}} > Rate</Button> {" "}
                                                    <Button variant='contained' color={data.is_slot_live ? 'success' : 'error'} size="small" onClick={() => slotLiveUpdate(data.is_slot_live ? { is_slot_live: false } : { is_slot_live: true }, data.match_id, data.series_id)}  sx={{ marginTop: "8px", backgroundColor: data.is_slot_live ? "success" : "error" }} > Slot</Button>
                                                </TableCell>
                                                {!gst && <>

                                                    <TableCell align="left">
                                                        <Button variant='contained' color={data.is_trade_avail ? 'success' : 'error'} size="small" onClick={() => matchStatusUpdate(data.is_trade_avail ? { is_trade_avail: false } : { is_trade_avail: true }, data.match_id, data.series_id)} > {data.is_trade_avail ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    {userProfile.accessLevel > 60 && <TableCell align="left">
                                                        <Button variant='contained' color={data.is_in_play_avail ? 'success' : 'error'} size="small" onClick={() => matchStatusUpdate(data.is_in_play_avail ? { is_in_play_avail: false } : { is_in_play_avail: true }, data.match_id, data.series_id)} > {data.is_in_play_avail ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>}

                                                    <TableCell align="left">
                                                        <Button variant='contained' color={data.is_skiller_avail ? 'success' : 'error'} size="small" onClick={() => matchStatusUpdate(data.is_skiller_avail ? { is_skiller_avail: false } : { is_skiller_avail: true }, data.match_id, data.series_id)} > {data.is_skiller_avail ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    {/* <TableCell align="left">
                                                <Button variant='contained' color={data.is_poll_avail ? 'success' : 'error'} size="small" onClick={() => matchStatusUpdate(data.is_poll_avail ? { is_poll_avail: false } : { is_poll_avail: true }, data.match_id, data.series_id)} disabled={data.total_contest > 0 ? false : true}> {data.is_poll_avail ? 'Active' : 'InActive'}</Button>
                                            </TableCell> */}
                                                    {/* <TableCell align="left">
                                                <Button variant='contained' color={data.is_opinion_pro_avail ? 'success' : 'error'} size="small" onClick={() => matchStatusUpdate(data.is_opinion_pro_avail ? { is_opinion_pro_avail: false } : { is_opinion_pro_avail: true }, data.match_id, data.series_id)} disabled={data.total_contest > 0 ? false : true}> {data.is_opinion_pro_avail ? 'Active' : 'InActive'}</Button>
                                            </TableCell> */}
                                                </>}
                                                {gst && <TableCell align="left">
                                                    <Link to={{ pathname: `/match_data/${data.match_id}` }}><Button variant='contained' color={'secondary'} size="small">Match Data</Button></Link>
                                                </TableCell>}
                                                {!gst &&
                                                    contextName === 'LIVE' &&
                                                    <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                        <Grid container style={{ display: "flex", background: '#fff' }}>
                                                            <TextField type='number' width={'50px'} size='small' id="outlined-basic" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort ? sort[data._id]?.sort : data.sort} />
                                                            <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                        </Grid>
                                                    </TableCell>
                                                }
                                                {!gst && contextName === 'LIVE' && (
                                                <TableCell align="left">
                                                    <Button
                                                    variant="contained"
                                                    color="warning"
                                                    size="small"
                                                    onClick={() => moveToFinished(data.match_id, data.series_id,data._id, data.is_trade_avail)}
                                                    >
                                                    Move to Finished
                                                    </Button>
                                                </TableCell>
                                                )}

                                                {!gst &&
                                                    contextName === 'UPCOMING' &&
                                                    <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                        <Grid container style={{ display: "flex", background: '#fff' }}>
                                                            <TextField type='number' width={'50px'} size='small' id="outlined-basic" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort ? sort[data._id]?.sort : data.sort} />
                                                            <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                        </Grid>
                                                    </TableCell>
                                                }
                                                {!gst && <TableCell align="left">
                                                    {data.match_status === 'Cancelled' ? <h4 style={{ color: "red", margin: "0px 0px", textAlign: "center" }}>Cancelled Match</h4> : ''}
                                                    {
                                                        // data.total_contest > 0 ?
                                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                            <InputLabel id="demo-simple-select-filled-label">Prediction</InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-filled-label"
                                                                key={data.match_id}
                                                            >

                                                                <MenuItem value={''}>Select Option</MenuItem>
                                                                <MenuItem value={3} sx={{ 'padding': 0 }}><Link to={`/matchlist/trading/${data.match_id}/${data.series_id}/${data.sport}`} style={{ display: 'block', width: '100%', padding: 10 }}>Trading</Link></MenuItem>
                                                                {userProfile.accessLevel > 60 && <MenuItem value={4} sx={{ 'padding': 0 }}><Link to={`/matchlist/in_play/${data.match_id}/${data.series_id}/${data.sport}`} style={{ display: 'block', width: '100%', padding: 10 }}>Quiz Play</Link></MenuItem>}
                                                                <MenuItem value={5} sx={{ 'padding': 0 }}><Link to={`/matchlist/skiller/${data.match_id}/${data.series_id}/${data.sport}`} style={{ display: 'block', width: '100%', padding: 10 }}>Skiller</Link></MenuItem>
                                                                {/* <MenuItem sx={{ 'padding': 0 }} value={1}><Link to={`/matchlist/poll/${data.match_id}/${data.series_id}/${data.sport}`} style={{ display: 'block', width: '100%', padding: 10 }}>Poll</Link></MenuItem> */}
                                                                {/* <MenuItem value={2} sx={{ 'padding': 0 }}><Link to={`/matchlist/opinion_pro/${data.match_id}/${data.series_id}/${data.sport}`} style={{ display: 'block', width: '100%', padding: 10 }}>Opinion Pro</Link></MenuItem> */}
                                                            </Select>
                                                        </FormControl>
                                                        // : <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                        //     <InputLabel id="demo-simple-select-filled-label">Prediction</InputLabel>
                                                        //     <Select
                                                        //         labelId="demo-simple-select-filled-label"
                                                        //         key={data.match_id}
                                                        //     >
                                                        //     </Select>
                                                        // </FormControl>
                                                    }
                                                </TableCell>}
                                                <TableCell align="center">
                                                    <FormControlLabel
                                                        control={
                                                        <Switch
                                                            checked={data.has_analytics === true}
                                                            onChange={(e) =>
                                                            handleAnalyticsToogle(
                                                                e.target.checked.toString(), // "true" or "false"
                                                                data.match_id,
                                                                data.series_id
                                                            )
                                                            }
                                                            color="success" // green when checked
                                                        />
                                                        }
                                                        label={data.has_analytics ? "Active" : "Inactive"}
                                                        labelPlacement="end"
                                                    />
                                                    </TableCell>
                                            </TableRow>

                                        )) : loading ? 
                                        <Box sx={{
                                            position: 'fixed',
                                            top: 0,
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            zIndex: 9999, // Ensure it stays above other elements
                                            paddingTop: '30%', // Space from top of the page
                                        }}>
                                            <CircularProgress></CircularProgress>
                                        </Box> 
                                        : <TableCell colSpan={12} ><h3 style={{ textAlign: "center" }}>No Data Found</h3></TableCell>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Stack spacing={2}>
                                {
                                    listData.length > 0 &&
                                    <Pagination count={totalPage} page={defaultPage} color="primary" onChange={handlePagination} />
                                }
                            </Stack>
                        </TabPanel>
                    </TabContext>
                    <ScoreCardDialog toggleScoreCard={toggleScoreCard} setToggleScoreCard={setToggleScoreCard}></ScoreCardDialog>
                </Box>
                <Dialog open={dialogOpen} onClose={handleDialogClose}>
                    <DialogTitle>Enter Activation Time</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                        Please enter the live activation time. It must not be later than the match start time (
                        <strong>{selectedMatch?.star_time} {selectedMatch?.star_date}</strong>).
                        </DialogContentText>
                        <TextField
                        autoFocus
                        margin="dense"
                        label="Live Activation Time"
                        type="datetime-local"
                        fullWidth
                        value={selectedTime}
                        onChange={(e) => setSelectedTime(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose}>Cancel</Button>
                        <Button onClick={handleDialogConfirm} variant="contained" color="primary">
                        Confirm
                        </Button>
                    </DialogActions>
                </Dialog>    
        </>
    );
}

const ScoreCardDialog = (props) => {

    const { toggleScoreCard, setToggleScoreCard } = props;
    const [scorecard, setScorecard] = React.useState("");
    const [teamDetails, setTeamDetails] = React.useState({
        team_a_short: "",
        team_b_short: "",
        battting_team_name:""
    })

    const getScoreCardDetails = async () => {
        const response = await axios.get(`${GET_SCORE_CARD}`.replace(':match_id', toggleScoreCard.match_id).replace(":series_id", toggleScoreCard.series_id))
            if (response?.data?.status) {
                setScorecard(response?.data?.data)
            }
    }
    const changeTeamDetails = async () => {
        let request = {}
        if (teamDetails.team_a_short) request["team_a_short"] = teamDetails.team_a_short 
        if(teamDetails.team_b_short ) request["team_b_short"] = teamDetails.team_b_short 
        if (teamDetails.battting_team_name) request["battting_team_name"] = teamDetails.battting_team_name 
        
        if (!Object.keys(request).length)
        {
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Please fill atleast one field!',
                showConfirmButton: false,
                timer: 1500
            })
            return;
            }

        const response = await axios.post(`${SET_TEAM_DETAILS}`.replace(':match_id', toggleScoreCard.match_id).replace(":series_id", toggleScoreCard.series_id), request)
        if (response?.data?.status) {
            setToggleScoreCard({ ...toggleScoreCard, isOpen: false })
            setTeamDetails({
                team_a_short: "",
             team_b_short: "",
             battting_team_name:""})
               Swal.fire("Added Successfully")
            }
    }
    const handleChange = (event) => {
        setTeamDetails({
            ...teamDetails,
            [event.target.name]:event.target.value
        })
    }
   const closeDialog = () => {
        setToggleScoreCard({ ...toggleScoreCard, isOpen: false, match_id: "", series_id: "" });
       setTeamDetails({
           team_a_short: "",
        team_b_short: "",
        battting_team_name:""})

    }
    React.useEffect(() => {
        if(toggleScoreCard.isOpen)
            getScoreCardDetails("72997", "128423")
    }, [toggleScoreCard])
    
    return (
        <Dialog open={toggleScoreCard.isOpen} onClose={()=>closeDialog()} >
           
            <Box  spacing={0.5} direction="row" useFlexGap flexWrap="wrap" style={{padding:"20px 40px"}}>
            
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>Team Details</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={()=>closeDialog()}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                    </Grid>
                <hr />
                
               
                <Grid container spacing={1}>
                    <Grid xs={12} item>
                        <Typography>{`Team A Short : ${scorecard?.team_a_short || "NA"}`}</Typography>
                    </Grid>
                    <Grid xs={12} item>
                        <Typography>{`Team B Short : ${scorecard?.team_b_short || "NA"}`}</Typography>
                    </Grid>
                    <Grid xs={12} item>
                        <Typography>{`Batting Team Name : ${scorecard?.battting_team_name || "NA"}`}</Typography>
                        </Grid>
                
                        <Grid xs={12} item>
                            <h2 id="modal-title" mb={1}>Edit Team Details</h2>
                        </Grid>
                    
                        <Grid xs={6} item>
                            <InputLabel>Team A Short Name : </InputLabel>
                            <TextField id="outlined-basic" type='text' size={'small'} variant="outlined" name={'team_a_short'} value={teamDetails.team_a_short}  onChange={handleChange}  />
                        </Grid>
                        <Grid xs={6} item>
                            
                            <InputLabel>Team B Short Name : </InputLabel>
                            <TextField id="outlined-basic" type='text' size={'small'} variant="outlined" name={'team_b_short'}  value={teamDetails.team_b_short}  onChange={handleChange}/>
                        </Grid>

                       <Grid xs={12} item>
                            <InputLabel>Batting Team : </InputLabel>
                            <TextField id="outlined-basic" type='text' size={'small'} variant="outlined" name={'battting_team_name'}  value={teamDetails.battting_team_name}  onChange={handleChange} />
                        </Grid>
                       
                </Grid>
                <Grid  textAlign={'right'}>
                                    <Button  variant="contained" onClick={()=> changeTeamDetails("72997", "128423")} >Submit</Button>
                    </Grid>
                </Box>
        </Dialog>
    )
}